import React, { Component } from "react";
import axios from "axios";
import { getUser } from "../../../../actions/session";
import { Notifications } from "../../../common/notification";
import { ACCOUNT_TAB_STIR_SHAKEN, CARRIER_LISTING } from "../../../../config/rest_endpoints";

class UpdateSubjectBlock extends Component {
  constructor(props) {
    super(props);
    this.state = {
      User: getUser(),
      subject: "",
      note: "",
      isLoad: false,
      blockId: this.props.previousData.id || "",
      id: "",
      accountID: '',
      carriers: [],
      selectedCarriers: [],
      allSelected: true,
      isCarrierLoading: false
    };

    this.handleChange = this.handleChange.bind(this);
    this.onSubmitChange = this.onSubmitChange.bind(this);
    this.handleCarrierChange = this.handleCarrierChange.bind(this);
    this.handleAllCarriersChange = this.handleAllCarriersChange.bind(this);
  }

  componentDidMount() {
    this.fetchCarriers();
  }

  componentWillReceiveProps(newProps) {
    console.log('previousData', newProps);
    const blockedAccountNames = newProps.previousData.blockedAccounts || [];
    const { carriers } = this.state;
    const selectedCarriers = carriers
      .filter(carrier => blockedAccountNames.includes(carrier.name))
      .map(carrier => carrier.id);
    const allSelected = selectedCarriers.length === carriers.length;
    this.setState({
      subject: newProps.previousData.stirShakenSubject,
      note: newProps.previousData.note,
      id: newProps.previousData.id,
      accountID: newProps.previousData.accountID,
      selectedCarriers,
      allSelected
    });
  }

  fetchCarriers() {
    const { User } = this.state;
    this.setState({ isCarrierLoading: true });
    
    const headers = { Authorization: `Bearer ${User.token}` };
    
    axios.get(CARRIER_LISTING, { headers })
      .then((res) => {
        if (res.data && res.data.data) {
          const carriersData = res.data.data.carriers;
          console.log("carriersData", carriersData)
          // Set all carriers as selected by default
          const allCarrierIds = carriersData.map(carrier => carrier.id);
          console.log("allCarrierIds", allCarrierIds)
          this.setState({ 
            carriers: carriersData,
            selectedCarriers: allCarrierIds,
            allSelected: true,
            isCarrierLoading: false 
          });
        }
      })
      .catch((err) => {
        console.error('Error fetching carriers:', err);
        this.setState({ isCarrierLoading: false });
        Notifications.notify("Failed to fetch carriers", "Error", "error");
      });
  }

  handleAllCarriersChange(e) {
    const { carriers } = this.state;
    const allSelected = e.target.checked;
    
    if (allSelected) {
      // Select all carriers
      const allCarrierIds = carriers.map(carrier => carrier.id);
      this.setState({ 
        allSelected: true, 
        selectedCarriers: allCarrierIds 
      });
    } else {
      // Deselect all carriers
      this.setState({ 
        allSelected: false, 
        selectedCarriers: [] 
      });
    }
  }

  handleCarrierChange(carrierId) {
    const { selectedCarriers, carriers } = this.state;
    let newSelectedCarriers;
    
    if (selectedCarriers.includes(carrierId)) {
      // Remove carrier from selection
      newSelectedCarriers = selectedCarriers.filter(id => id !== carrierId);
    } else {
      // Add carrier to selection
      newSelectedCarriers = [...selectedCarriers, carrierId];
    }
    
    // Check if all carriers are selected
    const allSelected = newSelectedCarriers.length === carriers.length;
    
    this.setState({ 
      selectedCarriers: newSelectedCarriers,
      allSelected: allSelected
    });
  }

  handleChange(e) {
    this.setState({ [e.target.name]: e.target.value });
  }

  onSubmitChange() {
    const { subject, note, User, blockId, id, accountID, selectedCarriers, carriers } = this.state;

    if (!subject) {
      Notifications.notify("Subject field is required", "Error", "error");
      return;
    }

    // Prepare blockedAccountsID array
    let blockedAccountsID = [];
    if (this.state.allSelected) {
      // If "All" is selected, send all carrier IDs
      blockedAccountsID = carriers.map(carrier => carrier.id);
    } else {
      // Send only selected carrier IDs
      blockedAccountsID = selectedCarriers;
    }

    const payload = {
      id,
      stirShakenSubject: subject,
      accountID: accountID,
      note,
      blockedAccountsID,
      tab: "account"
    };

    console.log("payload", payload)
    this.setState({ isLoad: true });

    const headers = { Authorization: `Bearer ${User.token}` };

    axios
      .put(`${ACCOUNT_TAB_STIR_SHAKEN}`, payload, { headers })
      .then((res) => {
        this.setState({ isLoad: false });
        this.props.close();
        this.props.classListing();
        Notifications.notify(
          "Subject block updated successfully",
          "Success",
          "success"
        );
      })
      .catch((err) => {
        const message = err.response.data.message || "Update failed";
        this.setState({ isLoad: false });
        Notifications.notify(message, "Error", "error");
      });
  }

  render() {
    const { subject, note, isLoad, carriers, selectedCarriers, allSelected, isCarrierLoading } = this.state;
    console.log("carriers", carriers)

    const labelStyle = {
        fontWeight: '500',
        fontSize: '13px',
        color: '#475569',
        marginBottom: '6px'
    };

    return (
      <div>
        <div className="row">
          <div className="col-md-12">
            <div className="form-group">
              <label style={labelStyle}>Stir Shaken Subject</label>
              <input
                type="text"
                className="form-control"
                name="subject"
                value={subject}
                onChange={this.handleChange}
                placeholder="Enter subject"
              />
            </div>
          </div>

          <div className="col-md-12">
            <div className="form-group">
              <label style={labelStyle}>Carriers</label>
              <div>
                <div style={{
                    display:'flex',
                    alignItems:'center',
                    gap:'10px',
                    padding:'10px 14px',
                    background:'#ECFDF5',
                    borderRadius:'10px 10px 0 0',
                    border:'1px solid #E2E8F0',
                    borderBottom:'none'
                }}>
                  <input
                    type="checkbox"
                    id="allCarriersUpdate"
                    checked={allSelected}
                    onChange={this.handleAllCarriersChange}
                    style={{width:'16px',height:'16px',accentColor:'#10B981',cursor:'pointer'}}
                  />
                  <label htmlFor="allCarriersUpdate" style={{fontSize:'13px',fontWeight:'600',color:'#047857',margin:0,cursor:'pointer'}}>
                    All Carriers
                  </label>
                </div>

                {carriers && carriers.length > 0 && (
                  <div style={{
                      maxHeight: '150px',
                      overflowY: 'auto',
                      border: '1px solid #E2E8F0',
                      padding: '8px 14px',
                      borderRadius: '0 0 10px 10px'
                  }}>
                    {carriers.map((carrier) => (
                      <div key={carrier.id} style={{display:'flex',alignItems:'center',gap:'10px',padding:'6px 0'}}>
                        <input
                          type="checkbox"
                          id={`carrier-update-${carrier.id}`}
                          checked={selectedCarriers.includes(carrier.id)}
                          onChange={() => this.handleCarrierChange(carrier.id)}
                          style={{width:'15px',height:'15px',accentColor:'#10B981',cursor:'pointer'}}
                        />
                        <label htmlFor={`carrier-update-${carrier.id}`} style={{fontSize:'13px',color:'#475569',margin:0,cursor:'pointer'}}>
                          {carrier.name || carrier.carrierName || `Carrier ${carrier.id}`}
                        </label>
                      </div>
                    ))}
                  </div>
                )}

                {(!carriers || carriers.length === 0) && (
                  <div style={{
                      padding: '16px',
                      border: '1px solid #E2E8F0',
                      borderRadius: '0 0 10px 10px',
                      background: '#F8FAFC',
                      textAlign: 'center'
                  }}>
                    <span style={{fontSize:'12px',color:'#94A3B8'}}>No carriers available</span>
                  </div>
                )}
              </div>
            </div>
          </div>

          <div className="col-md-12">
            <div className="form-group">
              <label style={labelStyle}>Note</label>
              <textarea
                className="form-control"
                name="note"
                value={note}
                onChange={this.handleChange}
                placeholder="Enter note"
                rows="4"
              />
            </div>
          </div>
        </div>

        <div style={{borderTop:'1px solid #E2E8F0',marginTop:'16px',paddingTop:'20px',display:'flex',justifyContent:'flex-end'}}>
            <button
              type="button"
              disabled={isLoad}
              onClick={this.onSubmitChange}
              style={{
                  background: isLoad ? '#94A3B8' : 'linear-gradient(135deg, #10B981, #059669)',
                  color: '#FFFFFF',
                  border: 'none',
                  borderRadius: '10px',
                  padding: '10px 24px',
                  fontSize: '13px',
                  fontWeight: '600',
                  cursor: isLoad ? 'not-allowed' : 'pointer',
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: '8px',
                  boxShadow: isLoad ? 'none' : '0 4px 12px rgba(16, 185, 129, 0.3)',
                  transition: 'all 200ms ease'
              }}
            >
              {isLoad ? (
                <><i className="icon-spinner4 spinner" style={{fontSize:'14px'}}></i> Updating...</>
              ) : (
                <><i className="icon-pencil5" style={{fontSize:'14px'}}></i> Update</>
              )}
            </button>
        </div>
      </div>
    );
  }
}

export default UpdateSubjectBlock;
